// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { defaultCardStyles } from "@conklin/Overrides/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

defaultCardStyles.titleText = {
    variant: "h2",
    css: css`
        line-height: 36px;
        ${xScreen("lte", "sm")} {
            margin-bottom: 0;
        }
    `,
};

defaultCardStyles.mainWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        background-color: ${color("common.ui3")};
        margin-right: 12px;
        border-radius: 4px;

        ${xScreen("lte", "md")} {
            margin-right: 0;
            margin-bottom: 16px;
        }

        ${xScreen("lte", "sm")} {
            margin-top: 8px;
        }
    `,
};

defaultCardStyles.headerWrapper = defaultCardStyles.container = {
    css: css`
        display: flex;
        padding: 12px;
        align-items: center;
    `,
};

defaultCardStyles.descriptionText = {
    variant: "h6",
    css: css`
        margin: 5px 10px;
    `,
};

defaultCardStyles.deleteLinkGridItem = defaultCardStyles.editLinkGridItem = {
    width: [6, 6, 12, 12, 12],
    css: css`
        justify-content: center;
        margin-bottom: 20px;
        ${xScreen("lte", "sm")} {
            justify-content: flex-start;
        }
    `,
};

defaultCardStyles.offsetGridItem = {
    width: 12,
    css: css`
        min-height: 53px;
        ${xScreen("lte", "sm")} {
            min-height: unset;
        }
    `,
};

defaultCardStyles.billingAddressLabelText =
    defaultCardStyles.expirationLabelText =
    defaultCardStyles.nameOnCardLabelText =
        {
            weight: fontConfig.weight.bold,
            css: css`
                margin-bottom: 8px;
            `,
        };

defaultCardStyles.billingAddressText = defaultCardStyles.expirationText = {
    size: 14,
    css: css`
        line-height: 17px;
    `,
};

defaultCardStyles.nameOnCardText = {
    size: 14,
    css: css`
        margin-bottom: 20px;
        line-height: 17px;
    `,
};
